<script>
    import ScreenshotElement from "./screenshot-element.vue";
    import {Screenshot} from "./Screenshot";

    export default {
        components: {ScreenshotElement},
        props: {
            files: {
                type: Array
            }
        },
        methods: {
            typedScreenshot(data) {
                return new Screenshot(data);
            }
        }
    }
</script>

<template>
    <div class="mediapool-list" style="overflow: visible">
        <div :key="screenshot.clientId" v-for="screenshot in files" class="file-box mediapool-file-box">
            <screenshot-element
                :screenshotData="typedScreenshot(screenshot)"
            />
        </div>
    </div>
</template>
